document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".smart-nav-btn");
  const sections = document.querySelectorAll(".food-category-section");
  const smartMenuWrapper = document.querySelector('.smart-food-wrapper');
let lastActiveCategory = "";

  // CATEGORY BUTTON CLICK
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const targetId = this.getAttribute("data-target");
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });

  // ACTIVE TAB ON SCROLL
 window.addEventListener("scroll", function () {

  if (!smartMenuWrapper) return;

  const menuTop = smartMenuWrapper.offsetTop;
  const menuBottom = menuTop + smartMenuWrapper.offsetHeight;
  const scrollPos = window.pageYOffset + 200;

  // stop calculations when outside food menu
  if (scrollPos < menuTop || scrollPos > menuBottom) {
    return;
  }

  let current = "";

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 150;
    if (window.pageYOffset >= sectionTop) {
      current = section.getAttribute("id");
    }
  });

  tabs.forEach(tab => {
    tab.classList.remove("active");

    if (tab.getAttribute("data-target") === current) {
      tab.classList.add("active");

      if (lastActiveCategory !== current) {
        lastActiveCategory = current;

        tab.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      }
    }
  });

});

  // MANUAL CUSTOM AJAX ADD TO CART
  document.addEventListener("click", function(e){

    if(!e.target.matches('.smart-add-cart')){
      return;
    }

    e.preventDefault();

    const form = e.target.closest('.smart-product-form');
    const variantId = form.getAttribute('data-variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {

   fetch('/cart.js')
.then(r => r.json())
.then(cart => {

    const stickyCount = document.querySelector('.smart-cart-count');
    const stickyPrice = document.querySelector('.smart-cart-total');

    if (stickyCount) stickyCount.textContent = cart.item_count + ' items';
    if (stickyPrice) stickyPrice.textContent = '€' + (cart.total_price / 100).toFixed(2);

    const bubbles = document.querySelectorAll('.cart-count, .cart-count-bubble span');
    bubbles.forEach(el => {
      el.textContent = cart.item_count;
    });

    // refresh shopify drawer html
    fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(res => res.json())
    .then(sections => {

      const drawerWrapper = document.querySelector('cart-drawer');
      if (drawerWrapper && sections['cart-drawer']) {
        const temp = document.createElement('div');
        temp.innerHTML = sections['cart-drawer'];
        const newDrawer = temp.querySelector('cart-drawer');
        if (newDrawer) {
          drawerWrapper.innerHTML = newDrawer.innerHTML;
          drawerWrapper.classList.remove('is-empty');
        }
      }

      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble && sections['cart-icon-bubble']) {
        const temp2 = document.createElement('div');
        temp2.innerHTML = sections['cart-icon-bubble'];
        const newBubble = temp2.querySelector('#cart-icon-bubble');
        if (newBubble) {
          iconBubble.innerHTML = newBubble.innerHTML;
        }
      }

    });

});

    })
    .catch(error => {
      console.log('Cart Error:', error);
    });

  });

});